var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIconHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.838 12.667c3.032 0 5.49-2.388 5.49-5.334C13.327 4.388 10.87 2 7.837 2 4.807 2 2.35 4.388 2.35 7.333c0 2.946 2.457 5.334 5.488 5.334zM14.7 14l-2.985-2.9",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.158 5.576a1.488 1.488 0 00-1.1-.443c-.31.004-.61.11-.851.302-.13.103-.245.223-.34.358a1.728 1.728 0 00-.353-.346 1.399 1.399 0 00-.862-.273 1.485 1.485 0 00-1.083.48c-.28.316-.427.722-.412 1.138.021.48.222.936.564 1.282.425.44.885.845 1.376 1.212.19.152.407.325.63.508.123.1.303.098.422-.007.218-.192.427-.371.612-.53A11.38 11.38 0 0010.093 8c.33-.357.514-.82.518-1.3 0-.417-.162-.818-.453-1.124z",
    fill: "#FF4055"
  })));
}

export default SvgSearchIconHeart;